import React from 'react'
import services from 'services'
import LoginView from 'views/Login'
import Spinner from 'components/Spinner'

const hocCache: any = {}

export default function requiresLoggedIn<T>(component: T): T {
  if (hocCache[component]) {
    return hocCache[component]
  }

  const Component: any = component
  function HoCComponent(props: any) {
    const [isLoggedIn, isLoggingIn] = services.getAuthService().isLoggedIn.hook()

    if (isLoggingIn) {
      return (
        <div className="h-full flex flex-1 flex-col justify-center items-center">
          <Spinner />
        </div>
      )
    }

    if (isLoggedIn) {
      return <Component {...props} />
    } else {
      return <LoginView />
    }
  }
  HoCComponent.displayName = Component.displayName
  hocCache[component] = HoCComponent
  // @ts-ignore
  return HoCComponent as T
}
